module.exports = __webpack_public_path__ + "static/WEDDING E&M-411-86c833ab6ff55666ab192656ad446a6d.jpg";